// extracted by mini-css-extract-plugin
export default {"conteiner":"NotFound_conteiner__llBCK","conteiner__btn":"NotFound_conteiner__btn__YEfRK"};